import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserHistory } from "@tanstack/react-router";

import "./index.css";

import { insideHeyDayNewsApp } from "./appMode";
import { fitToVisualViewport } from "./visualViewportFit";
import { getRouter } from "./router";
import { AppRoot } from "./AppRoot";
import { clearChunkReloadGuard, reloadOnceForChunkLoadError } from "./lib/chunkReloadGuard";

if (import.meta.env.BASE_URL === "/heydex/") {
  const query = new URLSearchParams(window.location.search),
    report = query.get("report");
  if (report && /^[0-9a-f-]{36}$/.test(report)) {
    sessionStorage.setItem("heyday:research-context", report);
    query.delete("report");
    window.history.replaceState(
      null,
      "",
      window.location.pathname + (query.size ? `?${query}` : ""),
    );
  }
}

if (!insideHeyDayNewsApp && window.visualViewport && navigator.maxTouchPoints > 0) {
  fitToVisualViewport(window.visualViewport, document.documentElement);
}

const history = createBrowserHistory();

const router = getRouter(history);

// A failed split-chunk fetch usually means the hashed assets went stale under
// a deploy; one guarded reload picks up the fresh index.html.
let chunkLoadFailed = false;
let reloadScheduled = false;
window.addEventListener("vite:preloadError", (event) => {
  chunkLoadFailed = true;
  if (reloadOnceForChunkLoadError()) {
    reloadScheduled = true;
    event.preventDefault();
  }
});

const app = <AppRoot router={router} />;

// Hold the boot splash until the initial route's chunks are ready.
export const startup = router
  .load()
  .then(() => {
    if (reloadScheduled) return;
    if (!chunkLoadFailed) clearChunkReloadGuard();
    ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
      <React.StrictMode>{app}</React.StrictMode>,
    );
  })
  .catch((error: unknown) => {
    if (reloadScheduled) return;
    throw error;
  });
